module.exports = __webpack_public_path__ + "img/condition3.68b3467a.png";